import { createSlice } from '@reduxjs/toolkit'

export interface LayoutsSlice {
  presenterLayout: {
    presenterLayoutsActive: boolean
    sidebarActive: boolean
    layoutType: LayoutType
  }
  mediaLayout: {
    mediaSidebarActive: boolean
    mediaLayoutType: LayoutType
  }
}

export enum LayoutType {
  Gallery = 'gallery',
  Full = 'full',
  Sidebar = 'sidebar',
  Split = 'split'
}

export const layoutsDefaultState: LayoutsSlice = {
  presenterLayout: {
    presenterLayoutsActive: false,
    sidebarActive: false,
    layoutType: LayoutType.Full
  },
  mediaLayout:{
    mediaSidebarActive: false,
    mediaLayoutType: LayoutType.Full
  }
}

const layoutsSlice = createSlice({
  name: 'layouts',
  initialState: layoutsDefaultState,
  reducers: {
    setLayout( state, { payload }) {

      state.presenterLayout.presenterLayoutsActive = payload.presenterLayout?.presenterLayoutsActive
      state.presenterLayout.sidebarActive = payload.presenterLayout?.sidebarActive
      state.presenterLayout.layoutType = payload.presenterLayout?.layoutType
      state.mediaLayout.mediaSidebarActive = payload.mediaLayout?.mediaSidebarActive
      state.mediaLayout.mediaLayoutType = payload.mediaLayout?.mediaLayoutType

    }
  }

})

export default layoutsSlice